// Fixed copy for the sign-in screens (the till at /<client-id> and /admin),
// from the approved design in temp/login.html.
//
// The brand panel names the PRODUCT, not the club: both screens render before
// anyone has signed in, and the club's own name sits on the form card instead
// (config.courtName on a till, the product name on /admin).

/** The brand panel's headline. */
export const LOGIN_HEADLINE = 'Open your till.';

/** The line under the headline. Hidden on phones, where space goes to the form. */
export const LOGIN_SUBHEAD = 'Sign in to instantly resume daily business operations—sync real-time inventory, secure sales data, and streamline customer service.';

/** The ticked promises under the headline. Desktop only. */
export const LOGIN_ASSURANCES = [
  'Every action leaves an audit entry',
  'Stock updates the moment you sell',
  'Your own till, your own data',
];

/** The brand panel's footer line. */
export const LOGIN_BRAND_FOOT = 'Kawnter POS — by The Website Pal';

/** The till's form-card subtitle. */
export const LOGIN_TILL_SUBTITLE = 'Staff sign-in';

/** /admin's form-card subtitle. */
export const LOGIN_ADMIN_SUBTITLE = 'Administrator sign-in';

/** Placeholder in the email field — a shape, not a real address. */
export const LOGIN_EMAIL_PLACEHOLDER = 'you@yourbusiness.com';

/** Field-level messages, shown under the field that needs fixing. */
export const LOGIN_EMAIL_ERROR = 'Enter the email your manager set up for you.';
export const LOGIN_PASSWORD_ERROR = 'Enter your password.';
export const LOGIN_CAPS_LOCK_WARNING = 'Caps Lock is on.';

/**
 * What "Forgot password?" says. There is no reset email to send: staff
 * addresses are <name>@<client-id>.com, which are logins rather than
 * inboxes, so a reset link would go nowhere. The person who created the
 * account is the one who can set a new password.
 */
export const LOGIN_FORGOT_TILL = 'Staff passwords are set up by your store. Ask your manager to reset yours, then sign in with the new one.';
export const LOGIN_FORGOT_ADMIN = 'Administrator passwords are managed in the Firebase console (Authentication → Users). Reset it there, then sign in again.';

/** The reassurance line at the bottom of the card. */
export const LOGIN_TINY_NOTE = 'Your POS system is protected. Every sign-in is recorded in your audit trail.';

/**
 * Plain-text pattern the form checks before calling Firebase, so an obvious
 * typo is caught at the field instead of coming back as a generic error.
 */
export const LOGIN_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * How long the admin sign-out waits for its audit entry to leave before
 * signing out anyway. The entry is only writable while still signed in as the
 * administrator, so it has to go first — but an offline browser must not be
 * kept signed in waiting for it.
 */
export const LOGIN_SIGN_OUT_AUDIT_WAIT_MS = 1500;
